/* eslint react-hooks/exhaustive-deps: "warn" */


import { useRouter } from 'next/router';

import { Button } from 'ui/atoms/Button/Button';
import { Section } from 'ui/molecules/Section/Section';

import styles from './AIProductFinalCtaSection.module.scss';

export const AIProductFinalCtaSection = () => {
  const { asPath } = useRouter();

  return (
    <Section
      introBlockClassName={styles.intro}
      theme="dark"
      background="radial-gradient(ellipse 70% 130% at 50% 0%, rgba(21,101,216,0.18), transparent 70%), #0b1628"
      title="Your next research session starts with a conversation."
      description="Try Regis. Ask it anything about any company on Earth. See what an AI can do when it has real data behind it."
      actions={
        <Button
          type="white"
          size="xl"
          href={`https://platform.globaldatabase.com/public/signup/regis?origin=${process.env.HOST}${asPath}`}
          shadow
        >
          Get Started Free
        </Button>
      }
      className={styles.section}
    />
  );
};
